import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const listingsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.LISTING_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.LISTING_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.LISTING_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.LISTINGS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.LISTINGS_READ_SUCCESS:
      return {
        ...state,
        data, // Update the state with the fetched data
        error: false,
        loading: false,
      };
    case actions.LISTINGS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.LISTING_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.LISTING_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.LISTING_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case actions.LISTING_UPDATE_MEDIA_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.LISTING_UPDATE_MEDIA_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.LISTING_UPDATE_MEDIA_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const singleListingReducer = (state = initialStateSingle, action) => {
  switch (action.type) {
    case actions.LISTING_READ_BEGIN:
      return {
        ...state,
        data: null,
        loading: true,
      };

    case actions.LISTING_READ_SUCCESS:
      return {
        ...state,
        data: action.data, // Ensure action.data is correctly set
        error: null,
        loading: false,
      };

    case actions.LISTING_READ_ERR:
      return {
        ...state,
        error: action.err, // Ensure action.err is correctly set
        loading: false,
      };

    case actions.CLEAR_LISTING:
      return initialStateSingle;

    default:
      return state;
  }
};


export { listingsReducer, singleListingReducer };
